import classNames from 'classnames/bind';
import styles from './OmossInfinity.module.scss';
import dynamic from 'next/dynamic';
import { PrimaryButton } from '../../../components';

const ImageSlider = dynamic(() => import('./ImageSlider'), { ssr: false });

let cx = classNames.bind(styles);

export default function OmossInfinity({ data }) {
  if (!data) return null;

  // Handle both direct arrays and nodes structure
  const desktopImages = Array.isArray(data.infinityImagesDesktop) 
    ? data.infinityImagesDesktop 
    : data.infinityImagesDesktop?.nodes || [];
    
  const mobileImages = Array.isArray(data.infinityImagesMobile)
    ? data.infinityImagesMobile
    : data.infinityImagesMobile?.nodes || [];

  return (
    <section className={cx('infinitySection')}>
      <div className={cx('container')}>
        <div className={cx('content')}>
          <h2>{data.header}</h2>
          {data.subHeader && (
            <p>{data.subHeader}</p>
          )}
          {data.button?.buttonText && data.button?.buttonLink?.url && (
            <div className={cx('buttonWrapper')}>
              <PrimaryButton
                href={data.button.buttonLink.url}
                text={data.button.buttonText}
                external={data.button.buttonLink.target === '_blank'}
                light={true}
              />
            </div>
          )}
          <ImageSlider 
            desktopImages={desktopImages}
            mobileImages={mobileImages}
          />
        </div>
      </div>
    </section>
  );
}
